/**
 * Created by vwiny on 8/17/2018.
 */
import {
  AfterViewInit,
  Component, Input,
  OnInit,
} from '@angular/core';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';

@Component({
  selector: 'lm-set-asofdate',
  template: `
    <label
        soho-label
        [required]="true"
        for="date"
    ></label>
    <input
        name="date"
        soho-datepicker [options]="pickerOptions"
        [(ngModel)]="model.value" (change)="onChange($event)"
        attr.aria-label="{{ 'AsOfDateLabel' | translate }}"
    />
  `,
  providers: [ LMRouteComponentService ]
})

export class LMBannerAsOfDateDialogComponent implements OnInit, AfterViewInit {
  constructor(private lmErrorUtilService: LMErrorUtilService) {}

  public pickerOptions: SohoDatePickerOptions = {
    mode: 'standard',
    dateFormat: Soho.Locale.calendar().dateFormat.short,
    showMonthYearPicker: true
  };
  @Input() asOfDate: string;
  public model = {
    value: ''
  };

  ngOnInit() {
    if (this.asOfDate) {
      this.model.value = this.asOfDate;
    }
  }

  ngAfterViewInit() {
  }

  onChange(event) {
    this.asOfDate = this.model.value;
  }

  public getDate() {
    return this.asOfDate;
  }
}
